import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response } from '@angular/http';




import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { CommonService } from './common.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BindComponentService } from '../utils/bind.component.service';
import { ReportDownloadService } from './report.download.service';
/**
 * @author Wesley Mascarenhas
 * @version $Id: reports.consumption.service.ts 93106 2018-06-04 18:59:11Z thiago.h.neri $
 */
@Injectable()
export class ConsumptionReportService extends CommonService  {

  private localURL: string;
  private REPORTS_DOWNLOAD_PATH:string = '/datapackreportsdownload';
  private REPORTS_PATH:string = '/datapackreports';
  private localDownloadURL:string;

  constructor(public http: Http,public modalService: NgbModal,public bindComponent: BindComponentService, public reportDownloadService: ReportDownloadService) {
    super(http, modalService, bindComponent);
    this.localURL = this.baseURL + this.REPORTS_PATH;
    this.localDownloadURL = this.baseURL + this.REPORTS_DOWNLOAD_PATH;
  }

  public listConsumptions(reportType: string, consumptionType: string, detailType: string, pageNumber: number, fetchSize: number,initialCycle:string) {
    let url = this.localURL + '?action=listConsumption';
    url += '&reportType=' + reportType;
    url += '&consumptionType=' + consumptionType;
    url += '&detailType=' + detailType;
    url += '&initialCycle=' + initialCycle;
    
    if(pageNumber >= 0) {
      url += '&pageNumber=' + pageNumber;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }
    return this.convertResponse(this.httpGet(url));
  }
  
  public generateReport(reportType: string, consumptionType: string, detailType: string, pageNumber: number, fetchSize: number) {
    let url = this.localDownloadURL + '?action=listConsumption';
    url += '&reportType=' + reportType;
    url += '&consumptionType=' + consumptionType;
    url += '&detailType=' + detailType;
    if(pageNumber >= 0) {
      url += '&pageNumber=' + pageNumber;
    }
    if(fetchSize >= 0) {
      url += '&fetchSize=' + fetchSize;
    }


   this.reportDownloadService.prepare(url);

  }
  
}


// WEBPACK FOOTER //
// ./src/app/services/reports.consumption.service.ts